<template>
    <div class="bg">
        <div class="container">
            <h1>ХВАНЧ - Отзывы из зала</h1>
            <v-alert
                v-if="popup === true"
                :color="classPopUp"
                :icon="'$' + classPopUp"
                :text="textPopUp"
            ></v-alert>
            <form @submit.prevent="formSubmit" v-if="popup !== true">
                <label for="selectedDish">К чему относиться отзыв?</label>
                <v-select
                    clearable
                    id="selectedDish"
                    v-model="selectSubject"
                    :items="subject"
                    variant="outlined"
                    :rounded="'rounded-pill'"   
                ></v-select>
                <label for="selectedDish">Выбере зал, к которому относиться отзыв</label>
                <v-select
                    clearable
                    id="selectedHall"
                    v-model="selectHall"
                    :items="hall"
                    variant="outlined"
                    :rounded="'rounded-pill'"   
                ></v-select>
                <label for="selectedGrade">На что хотите оставить отзыв?</label>
                <v-text-field
                    id="selectedDish"
                    variant="outlined"
                    v-model="theme"
                    :rounded="'rounded-pill'"
                ></v-text-field>
                <label for="selectedGrade">Место для вашего комментария</label>
                <v-textarea
                    id="selectedCommentDish"
                    variant="outlined"
                    v-model="comment"
                    rounded="rounded-xl"       
                ></v-textarea>
                <v-btn 
                    variant="tonal"
                    type="submit"
                    size="large"
                    :disabled="comment === '' || submit === true ? true : false"
                    class="btn"
                >
                    Отправить
                </v-btn>
            </form>
        </div>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    data() {
        return {
            selectSubject: "Кухня",
            subject: [
                "Кухня",
                "Бар",
                "Другое",
            ],
            selectHall: "Зал на Первом Этаже",
            hall: [
                "Зал на Первом Этаже",
                "Зал на Втором Этаже",
            ],
            theme: '',
            comment: '',
            popup: false,
            textPopUp: '',
            classPopUp: '',
            submit: false
        }
    },
    methods: {
        async formSubmit() {
            this.submit = true

            this.popup = true;
            this.textPopUp = "Не покидайте страницу, пока не появиться сообщение об успешной отправке!";
            this.classPopUp = "info";

            const URI_API = `https://api.telegram.org/bot${process.env.VUE_APP_TOKEN}/sendMessage`

            let now = new Date();

            let message = `<b>Новый отзыв ${this.selectSubject === 'Кухня' ? 'по Кухне' : this.selectSubject === 'Бар' ? 'по Бару' : 'ко Всему ресторану'}!</b>\n`;
            message += `Из какого зала отзыв: ${this.selectHall}\n`
            message += `Тема Отзыва: <b>${this.theme}</b>\n`;
            message += `\n`;
            message += `Комментарий: <b>${this.comment}</b>\n`;
            message += `\n`;
            message += `Дата отправки <b>${now.getDate()}.${now.getMonth() + 1}.${now.getFullYear()} ${now.getHours()}:${now.getMinutes()}</b>\n`;

            await axios.post(URI_API, {
                    chat_id: process.env.VUE_APP_CHAT_FEEDBACK_ID,
                    parse_mode: "html",
                    text: message,
            })
            .then((res) => {

                    console.log(res);
            })
            .catch((err) => {

                    console.log(err);
            });

            const formData = new FormData();
            formData.append('Subject', this.selectSubject)
            formData.append('Hall', this.selectHall)
            formData.append('Сomment', this.comment)
            formData.append('Date', `${ now.getHours() }:${ now.getMinutes() < 10 ? '0'+ now.getMinutes() : now.getMinutes()} ${ now.getDate() }-${ now.getMonth() + 1 < 10 ? `0${now.getMonth() + 1}` : now.getMonth() + 1 }-${ now.getFullYear() }`);

            await axios.post(process.env.VUE_APP_GSHEETS_FEEDBACK, formData)
            .then(result => {
                console.log('Данные успешно отправлены в таблицу:', result);
                this.textPopUp = "Ваша заявка успешно отправленна!";
                this.classPopUp = "success";
            })
            .catch(error => {
                console.error('Ошибка при отправке данных в таблицу:', error);
                this.textPopUp = "Произошла какая-то ошибка! Попробуйте еще раз!";
                this.classPopUp = "error";
            });
            // this.popup = true;

            this.selectSubject = "Кухня"
            this.selectHall = "Зал на Первом Этаже"
            this.comment = ''
        }
    }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=PT+Sans+Narrow:wght@400;700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Amatic+SC:wght@400;700&display=swap');

.bg {
    background-image: url('../assets/djos.png');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    background-attachment: fixed;
    min-height: 100%;
    max-height: fit-content;
    width: 100%;
    padding: 50px 0px;
}
.v-btn {
    display: flex;
    border: 0px;
    border-radius: 50px;
    background-color: #e6ff00;
    font-family: "PT Sans Narrow";
    font-size: 22px;
    font-weight: 600;
}

.v-btn--disabled {
    background-color: grey;
    color: black;
}

.v-btn.v-btn--density-default {
    height: 60px;
    width: 200px;
}
.btn {
    position: relative;
    margin: 0 auto;
}

.v-slider.v-input {
    margin-top: 30px;
}

#selectedDish[data-v-e50ac4b0] > .v-input__control > .v-field {
    border-radius: 50px !important;
}

h1 {
    font-family: "PT Sans Narrow";
    font-weight: 700;
    /* text-align: center; */
    text-transform: uppercase;
    font-size: 40px;
}

label {
    font-family: "PT Sans Narrow";
    font-size: 30px;
    font-weight: 500;
    color: #000;
}

@media (max-width: 1000px) {
    h1 {
        font-size: 30px;
    }

    label {
        font-size: 20px;
    }

    .v-btn {
        font-size: 16px;
    }

    .v-btn.v-btn--density-default {
        height: 40px;
        width: 160px;
    }
}

@media (max-width: 600px) {
    h1 {
        font-size: 24px;
    }

    label {
        font-size: 20px;
    }
}
</style>